<template>
  <div class="page">
    <!-- <Head :headTitle="headTitle" /> -->
    <div class="welWord welWord1">欢迎参观</div>
    <div class="welWord welWord2">{{ welMsg }}</div>
  </div>
</template>
    
    <script>
import axios from "axios";
export default {
  data() {
    return {
      welMsg: "",
    };
  },
  components: {
    // Head,
    // bgAnimateVue,
  },
  computed: {},
  created() {
    this.getWelcome();
  },
  mounted() {},
  methods: {
    getWelcome() {
      axios
        .get(
          `http://zkscr.shouxinfund.com/dev-api/system/item/get/greet/XM03244988`
        )
        .then((res) => {
          console.log(res.data);
          this.welMsg = res.data.msg;
        });
      // axios({
      //     url:`http://zkscr.shouxinfund.com/dev-api/system/item/getGreet?itemId = XM03276791`,
      //     method:"GET",
      //     timeout:5000,
      // })
    },
  },
};
</script>
    <style scoped>
.page {
  /* position: relative; */
  background: url(../assets/images/welcome.png) no-repeat center;
  background-size: 100% 100%;
}
.page .welWord {
  font-family: "YouSheBiaoTiHei";
  width: 100%;
  text-align: center;
  letter-spacing: 10px;
  background: linear-gradient(#fff 50%, rgba(0, 0, 0, 0.15) 100%);
  -webkit-background-clip: text;
  color: transparent;

}
.welWord1{
  font-size: 240px;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -90%);
}
.welWord2{
  margin-top: 50px;
  font-size: 180px;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -40%);
}
</style>